import { ContractViewModel, ProductComponent, ServiceKind, ServiceViewModel } from '@ail/contracts-api'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { formatCurrencyToSwissLocale } from '../../../helpers/Utils'
import { Arr } from '../../../helpers/Arr'

const ServiceIcons: Partial<Record<ProductComponent, string>> = {
  [ProductComponent.ReplacementCar]: 'icon-reliefVehicle',
  [ProductComponent.Fuel]: 'icon-fuelcard',
  [ProductComponent.RoadTax]: 'icon-road-tax',
  [ProductComponent.Tires]: 'icon-tires',
  [ProductComponent.Vignette]: 'icon-vignette',
  [ProductComponent.LiabilityHandling]: 'icon-liability2',
  [ProductComponent.KaskoHandling]: 'icon-kasko2',
  [ProductComponent.Liability]: 'icon-liability2',
  [ProductComponent.Kasko]: 'icon-kasko2',
  [ProductComponent.CarWash]: 'icon-car-wash',
  [ProductComponent.MobilitySharingLicense]: 'icon-4u',
}

export function FinancialDetails(props: { contract?: ContractViewModel }) {
  const { t } = useTranslation('common')

  const getServiceLabel = useCallback(
    (service: ServiceViewModel) => {
      return t(`${service.name?.toUpperCase().replace(/\s+/g, '_')}`)
    },
    [t]
  )

  const feeServices = useMemo(() => {
    const filtered = props.contract?.services?.filter((s) => s.kind === ServiceKind.Fee && s.leasePrice > 0)
    return Arr.sort(filtered ?? [], (s) => getServiceLabel(s))
  }, [getServiceLabel, props.contract?.services])

  return (
    <div className="detailContentArea">
      <div className="detailTitle eyeOk">
        <i className="icon-cost"></i> <span>{t('FINANCIAL_DETAILS')}</span>
      </div>
      <div className="details">
        <div className="row">
          <div className="col-6">
            <div className="detailContent">
              <label>{t('PRICE')}</label>
              {props.contract?.leasePrice !== undefined ? formatCurrencyToSwissLocale(props.contract.leasePrice) : '-'}
            </div>
          </div>
          <div className="col-6">
            <div className="detailContent">
              <label>{t('INVESTMENT')}</label>
              {props.contract?.investment !== undefined ? formatCurrencyToSwissLocale(props.contract.investment) : '-'}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="detailContent">
              <label>{t('VEHICLE_VALUE')}</label>
              {props.contract?.vehicle?.netPrice !== undefined
                ? formatCurrencyToSwissLocale(props.contract.vehicle.netPrice)
                : '-'}
            </div>
          </div>
          <div className="col-6">
            <div className="detailContent">
              <label>{t('RESIDUAL_VALUE')}</label>
              {props.contract?.residualValue !== undefined
                ? formatCurrencyToSwissLocale(props.contract.residualValue)
                : '-'}
            </div>
          </div>
        </div>
        {feeServices.length > 0 && (
          <div className="feesArea">
            <div className="detailTitle">
              <i className="icon-doc-invoice" />
              {t('FEES')}
            </div>
            <div className="details">
              <div className="row">
                {feeServices.map((s, index) => (
                  <div className="col-6" key={s.leasePrice + index}>
                    <div className="detailContent">
                      <label>
                        <i className={ServiceIcons[s.product] ?? 'icon-4u'}></i>
                        <span>{getServiceLabel(s)}</span>
                      </label>
                      {formatCurrencyToSwissLocale(s.leasePrice)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
